export default __webpack_public_path__ + "static/media/A40E.2c1c73a6.jpg";